import React, { FC } from 'react';
import ComingSoonSignals from './coming-soon-signals';

const ConversionSignals: FC = () => {
	return <ComingSoonSignals signal="conversion" />;
};

export default ConversionSignals;
